export function RadioGroup({
    title,
    options,
    value,
    customClassName = '',
    getLabel = (value) => { return value },
    onChange,
}) {
    return (
        <div className={`filter-group filter-hover${customClassName}`}>
            <button
                type="button"
                className="filter-title truco-button"
                aria-haspopup="true"
            >{title ? title + " : " : ""}<span className="filter-summary">{getLabel(value)}</span></button>

            <ul className="filter-options">
                {options.map((opt) => (
                    <li key={String(opt)} className="filter-item">
                        <label>
                            {getLabel(opt)}
                            <input
                                type="radio"
                                name={title}
                                checked={value === opt}
                                onChange={() => onChange(opt)}
                            />
                        </label>
                    </li>
                ))}
            </ul>
        </div>
    );
}